import React from 'react'
import CreatableSelect from 'react-select/creatable';

class MultiSelect extends React.Component{

    state={
        menu:false
    }

    handleInputChange = (query, { action }) => {
            if(query.length!==0){
                this.setState({ menu: true });
            }
            else{
                this.setState({menu:false})
            }
    };
    render(){
        return(
            <CreatableSelect
                                        formatCreateLabel={userInput => `${userInput}`}
                                        isMulti
                                        onInputChange={this.handleInputChange}
                                        // onChange={this.handleChange}
                                        options={this.props.options}
                                        defaultValue= {this.props.defaultValue}
                                        placeholder="Skill (example: Java)"
                                        onChange={this.props.skills}
                                        openMenuOnFocus={false}
                                        tabIndex={this.props.tabNo}
                                        // openOnFocus={false}
                                        // openOnClick={false}
                                        // openMenuOnClick={false}
                                        menuIsOpen={this.state.menu}
                                        formatCreateLabel={userInput => `+ Add "${userInput}"`}                 
                                        styles={{
                                            control: (base) => ({ ...base, margin:"0",color: 'white',border:"1px solid",borderBottom:"1px solid lightgrey",
                                            '&:hover': {
                                                border:"1px solid !important",
                                                borderBottom:"1px solid lightgrey !important",
                                                borderRadius: '0'
                                            },
                                            '&:focus-within': {
                                                borderBottom:"1px solid lightgrey !important",
                                                boxShadow:"none !important",
                                                outline:"none !important",
                                                outlineWidth:"0 !important"
                                            }
                                            }),
                                            container: (base) => ({ ...base,position:"relative",top:"-5px", color:'black',border:'none' }),
                                            clearIndicator : (base) => ({ ...base, color: 'black',border:'none' }),
                                            singleValue : (base) => ({ ...base, color: 'black',backgroundColor:"red",color:"red" }),
                                            multiValue:(base) => ({ ...base, color: 'black',borderRadius:"15px",paddingLeft:"6px"}),
                                            
                                            multiValueRemove: (base) => ({ ...base, color: 'orange','&:hover': {
                                                border:"none !important",
                                                color:"orange !important",
                                                backgroundColor:"lightgrey !important",
                                                
                                            }}),
                                            multiValueLabel : (base) => ({ ...base, fontWeight:"bold"}),
                                            indicatorsContainer : (base) => ({ ...base, backgroundColor:"blue",display:"none"}),
                                            valueContainer :(base)=>({...base,padding:"-50px",position:"relative",bottom:"0px"}),
                                            placeholder:(base)=>({...base,marginTop:"6px"}),
                                            input :(base)=>({...base,marginTop:"6px"}), 
                                        }
                                        }
                                    />
            )
        
    }
}

export default MultiSelect